// src/app/redux/reducers/skillsReducer.js

import {
    FETCH_SKILLS_REQUEST, FETCH_SKILLS_SUCCESS, FETCH_SKILLS_FAIL,
    FETCH_SKILLS_BY_TYPE_SUCCESS, FETCH_SKILLS_BY_TYPE_FAIL,
    CREATE_SKILL_REQUEST, CREATE_SKILL_SUCCESS, CREATE_SKILL_FAIL,
    UPDATE_SKILL_REQUEST, UPDATE_SKILL_SUCCESS, UPDATE_SKILL_FAIL,
    DELETE_SKILL_REQUEST, DELETE_SKILL_SUCCESS, DELETE_SKILL_FAIL,
    DOWNLOAD_SKILLS_TEMPLATE_REQUEST, DOWNLOAD_SKILLS_TEMPLATE_SUCCESS, DOWNLOAD_SKILLS_TEMPLATE_FAIL,
    IMPORT_SKILLS_EXCEL_REQUEST, IMPORT_SKILLS_EXCEL_SUCCESS, IMPORT_SKILLS_EXCEL_FAIL,
    CLEAR_SKILLS_IMPORT_RESULT,
    EXPORT_SKILLS_REQUEST, EXPORT_SKILLS_SUCCESS, EXPORT_SKILLS_FAIL,
    SET_SKILLS_LOADING, SET_SKILLS_BULK_LOADING, CLEAR_SKILLS_ERROR,
} from "../actions/skillsActions";

const initialState = {
    list:         [],
    loading:      false,
    bulkLoading:  false,
    error:        null,
    importResult: null,
};

export default function skillsReducer(state = initialState, action) {
    switch (action.type) {

        case SET_SKILLS_LOADING:      return { ...state, loading:     action.payload };
        case SET_SKILLS_BULK_LOADING: return { ...state, bulkLoading: action.payload };
        case CLEAR_SKILLS_ERROR:      return { ...state, error: null };
        case CLEAR_SKILLS_IMPORT_RESULT: return { ...state, importResult: null };

        // CRUD — loading
        case FETCH_SKILLS_REQUEST:
        case CREATE_SKILL_REQUEST:
        case UPDATE_SKILL_REQUEST:
        case DELETE_SKILL_REQUEST:
            return { ...state, loading: true, error: null };

        // CRUD — success
        case FETCH_SKILLS_SUCCESS:
            return { ...state, loading: false, list: action.payload || [] };

        case FETCH_SKILLS_BY_TYPE_SUCCESS:
            return { ...state, loading: false, list: action.payload || [] };

        case CREATE_SKILL_SUCCESS:
            return { ...state, loading: false, list: [...state.list, action.payload] };

        case UPDATE_SKILL_SUCCESS:
            return {
                ...state,
                loading: false,
                list: state.list.map((s) => (s.id === action.payload.id ? action.payload : s)),
            };

        case DELETE_SKILL_SUCCESS:
            return {
                ...state,
                loading: false,
                list: state.list.filter((s) => s.id !== action.payload.id),
            };

        // CRUD — fail
        case FETCH_SKILLS_FAIL:
        case CREATE_SKILL_FAIL:
        case UPDATE_SKILL_FAIL:
        case DELETE_SKILL_FAIL:
            return { ...state, loading: false, error: action.error || "Erreur" };

        case FETCH_SKILLS_BY_TYPE_FAIL:
            return { ...state, loading: false, error: action.payload };

        // Template / Export
        case DOWNLOAD_SKILLS_TEMPLATE_REQUEST:
        case EXPORT_SKILLS_REQUEST:
            return { ...state, bulkLoading: true, error: null };

        case DOWNLOAD_SKILLS_TEMPLATE_SUCCESS:
        case EXPORT_SKILLS_SUCCESS:
            return { ...state, bulkLoading: false };

        case DOWNLOAD_SKILLS_TEMPLATE_FAIL:
        case EXPORT_SKILLS_FAIL:
            return { ...state, bulkLoading: false, error: action.error || "Erreur" };

        // Import
        case IMPORT_SKILLS_EXCEL_REQUEST:
            return { ...state, bulkLoading: true, error: null, importResult: null };

        case IMPORT_SKILLS_EXCEL_SUCCESS:
            return { ...state, bulkLoading: false, importResult: action.payload || null };

        case IMPORT_SKILLS_EXCEL_FAIL:
            return { ...state, bulkLoading: false, error: action.error || "Erreur import Excel" };

        default:
            return state;
    }
}